import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api/bank-parsing' 
  : 'http://localhost:5001/api/bank-parsing';

/**
 * Create a new bank parsing job
 * @param {FormData} formData - Form data with files
 * @param {string|null} contactId - HubSpot contact ID
 * @returns {Promise<{jobId: string}>}
 */
export const createBankParsingJob = async (formData, contactId = null) => {
  try {
    const url = contactId 
      ? `${API_BASE_URL}/jobs?contactId=${encodeURIComponent(contactId)}`
      : `${API_BASE_URL}/jobs`;
    
    console.log('[JobAPI] Creating bank parsing job...');
    
    const response = await axios.post(url, formData, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    console.log('[JobAPI] Job created:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('[JobAPI] Error creating job:', error);
    throw error.response?.data?.error || error.message || 'Failed to create job';
  }
};

/**
 * Get job status
 * @param {string} jobId - Job ID
 * @returns {Promise<Object>}
 */
export const getBankParsingJobStatus = async (jobId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/jobs/${jobId}`, {
      withCredentials: true
    });
    
    return response.data;
  } catch (error) {
    console.error('[JobAPI] Error getting job status:', error);
    throw error.response?.data?.error || error.message || 'Failed to get job status';
  }
};

/**
 * Get job results
 * @param {string} jobId - Job ID
 * @returns {Promise<Object>}
 */
export const getBankParsingJobResult = async (jobId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/jobs/${jobId}/result`, {
      withCredentials: true
    });
    
    return response.data;
  } catch (error) {
    console.error('[JobAPI] Error getting job result:', error);
    throw error.response?.data?.error || error.message || 'Failed to get job result';
  }
};

/**
 * Get recent jobs for the user
 * @param {number} limit - Number of jobs to fetch
 * @returns {Promise<Array>}
 */
export const getRecentBankParsingJobs = async (limit = 10) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/jobs?limit=${limit}`, {
      withCredentials: true
    });
    
    return response.data.jobs || [];
  } catch (error) {
    console.error('[JobAPI] Error getting recent jobs:', error);
    throw error.response?.data?.error || error.message || 'Failed to get recent jobs';
  }
};
